@use "ui/styles/colorsOld";
@use "ui/styles/formFieldStates";
@use "ui/oldStyles/utils";
@use "ui/styles/fonts";

.nativeWrapper,
.pseudoWrapper {
  width: 100%;
}

.open {
  z-index: 9999;

  &:not(.up):not(.optionsGap) input {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  input:focus {
    border-color: colorsOld.$sapphireLightX1;
  }
}

// Tint the input inside the wrapper, not the wrapper, so the dropdown keeps its background.
.info input {
  @include formFieldStates.info;
}

$inputHeight: 24px;
$iconSize: 14px;

.nativeWrapper {
  display: block;
  border: 1px solid var(--input-border-color);
  border-radius: 4px;
  background: var(--background-color);
  color: var(--primary-color);

  &:focus {
    border-color: var(--primary-color);
    visibility: hidden;
  }
}

.activePanel {
  .button {
    input {
      box-shadow: 0 0 0 10000px transparent inset; // chrome autofill
      background-color: transparent;
      height: $inputHeight;
      overflow-x: hidden;
      text-overflow: ellipsis;
      padding-right: 28px;
    }
  }

  &.large {
    .option {
      background: colorsOld.$stoneLightX3;
    }
  }
}

.pseudoWrapper {
  position: relative;

  .iconWrapper {
    position: absolute;
    top: 0;
    right: 10px;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .clearButton,
  .toggleButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background: transparent;
    color: colorsOld.$stoneDark;
    cursor: pointer;
  }

  .clearButton:hover {
    color: colorsOld.$stoneDarkX1;
  }

  .optionIcon {
    position: absolute;
    top: 0;
    left: 6px;
    height: 100%;
    display: flex;
    align-items: center;
    color: colorsOld.$stoneDark;

    svg {
      flex-shrink: 0;
      width: $iconSize;
      height: $iconSize;
    }
  }

  .button {
    position: relative;

    &.hideInput {
      input {
        display: none;
      }
    }

    input {
      text-overflow: ellipsis;
      width: 100%;
      flex-grow: 2;
      padding-right: calc($iconSize);
    }

    &.hasClearControl input {
      padding-right: calc($iconSize * 2 + 12px);
    }

    &.hasActiveOptionIcon input {
      padding-left: calc($iconSize + 9px);
    }
  }

  .options {
    background: var(--background-color);
    color: var(--text-color);
    height: auto;
    display: none;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    position: absolute;
    width: 100%;
    overflow-y: hidden;
    padding: 0px;
    z-index: 9999;

    &.open {
      display: block;
      border: 1px solid var(--input-border-color);
      max-height: 200px;
      transform: translateY(-1px);
      right: 0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  }

  .optionsList {
    overflow-y: auto;
    height: auto;
    max-height: 188px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--thumb-background-color);
      border-radius: 3px;
    }

    --thumb-background-color: transparent;

    &:hover {
      --thumb-background-color: rgb(0, 0, 0, 0.2);
    }

    &.hideScrollbar {
      @include utils.scrollbar;
    }

    &.isAdditive {
      position: absolute;
      bottom: 0;
    }
  }

  .option {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 9px;
    padding-right: 6px;
    min-height: 16px;
    gap: 6px;
    min-width: 100%;

    &.isAdditive {
      font-weight: fonts.$medium;
      color: var(--text-color);
      border-radius: 4px;
      display: flex;
      align-items: center;
      min-width: unset !important;

      &:hover {
        background-color: var(--secondary-background-color);
        color: var(--secondary-text-color);
      }

      span {
        text-wrap: nowrap;
        white-space: nowrap;
        margin-bottom: -2px;
        text-transform: none !important;

        &::after {
          content: "";
        }
      }
    }

    &,
    * {
      cursor: pointer;
    }

    label {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 2px;

      .subLabel {
        color: var(--secondary-text-color);
        font-size: fonts.$relativeSmall;
        margin-left: auto;
      }
    }

    .labelRight {
      margin-left: auto;
      flex-shrink: 0;
    }

    svg {
      flex-shrink: 0;
      width: $iconSize;
      height: $iconSize;
    }

    .checkedOption {
      flex-shrink: 0;
      visibility: hidden;
    }

    &.optionThumbnail {
      padding-left: 0;
    }

    &.active,
    &:hover {
      background-color: var(--secondary-background-color);
      color: var(--selected-primary-text-color) !important;
    }

    &.selected {
      color: var(--secondary-text-color);

      .checkedOption {
        visibility: visible;
      }
    }

    &.noResults {
      color: colorsOld.$stone;

      &:hover {
        background: inherit;
      }
    }

    &.disabled,
    &.locked {
      color: colorsOld.$stone;
    }

    &.header {
      font-size: fonts.$relativeSmallX1;
      color: colorsOld.$stone;
      padding-top: 9px;
      position: sticky;
      top: 0;
      background-color: colorsOld.$white;
    }

    &.header,
    &.disabled,
    &.locked {
      &,
      * {
        cursor: default;
      }

      &.active,
      &:hover {
        color: colorsOld.$stone !important;
      }
    }

    .thumbnail {
      margin: 0 5px;
    }

    .intermediateArrow {
      display: inline;
      color: colorsOld.$stoneLight;
      margin-left: 4px;
    }

    .submenuChevron {
      flex-shrink: 0;
      color: colorsOld.$stoneDark;
    }

    .submenuChevronLeft {
      margin-right: 2px;
      transform: rotate(180deg);
    }
  }

  .optionWithSubmenuWrapper {
    position: relative;
    min-width: 100%;
  }

  .submenuContainer {
    position: absolute;
    left: 100%;
    top: 0;
    margin-left: 2px;
    min-width: 160px;
    max-width: 260px;
    background-color: var(--background-color);
    border: 1px solid var(--input-border-color);
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 10000;
    padding: 4px 0;
    max-height: 200px;
    overflow-y: auto;
  }

  .submenuOption {
    min-height: 16px;
    padding: 4px 9px;

    &:hover {
      background-color: var(--secondary-background-color);
    }
  }

  &.disabled,
  &.locked {
    &.lockIcon {
      cursor: default;
    }
  }

  &.hasThumbnail {
    .thumbnailWrapper {
      position: absolute;
      top: 0;
      left: 3px;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .button input {
      padding-left: 25px;
    }
  }
}

.large {
  .option {
    min-height: 40px;
  }
}

.mediumLarge {
  .option {
    min-height: 32px;
  }
}

.small {
  font-size: fonts.$small;

  input {
    height: auto;
    min-height: 36px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .option {
    min-height: 16px;
  }

  .iconWrapper {
    right: 6px;
  }
}

.medium {
  .option {
    min-height: 16px;
  }

  .iconWrapper {
    right: 6px;
  }
}

.up {
  input {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  .options.open {
    bottom: $inputHeight;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    transform: translateY(1px);
  }
}

.optionsGap {
  input {
    border-radius: 4px;
  }

  .options.open {
    border-radius: 4px;
  }

  &.up {
    .options.open {
      transform: translateY(-3px);
    }
  }
}

.tooltipContent {
  max-width: 200px;
  font-size: fonts.$small;
}
